import { useState, useContext, useEffect } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../../Context";
import { BsPencil, BsThreeDotsVertical } from "react-icons/bs";
import { PiStudent, PiPencil, PiBuildingsLight } from "react-icons/pi";
import { MdOutlineArrowLeft } from "react-icons/md";
import { LuSheet } from "react-icons/lu";


import Fetch, { Loader, GET } from "../../../inc/Fetch"; 
import { ClassesDropdown } from "../../../components/Form"; 

import Task from "./Task"; 

import './css/Teacher_tasks.css'
import Games from './Games';

export default function Teachers_games() {

    const { t } = useTranslation();
    const location = useLocation();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    const [data, setdata] = useState({})
    const [isLoading, setisLoading] = useState(true)
    const [loading, setloading] = useState(false)
    const [filter, setfilter] = useState({})
    const [openOptions, setopenOptions] = useState(false)
    const [checked, setchecked] = useState([]);

    async function loadData() {
        let r = await GET(`games/myGames`);
        setdata(r);
        
        setisLoading(false);
    }

    const toggleSelectAll = () => {
        let arrData = [];
        if (checked?.length) {
            setchecked([]);
        } else {
            data.games?.map(v => {
    
                v.data?.map(v2 => {
                    arrData.push(v2?._id);
                })
            });
            setchecked(arrData);
        }
    };

    async function deleteGames() {
    
        const conf = window.confirm(t("error",  { returnObjects: true })[2]);
        if (!conf) {
            return false;
        }

        setloading(true);

        Fetch("games/deleteGames", (d) => {
  
            if (d?.error) {
                setopen({ error:true, short: t("error",  { returnObjects: true })[d?.error] });
            } else {
                loadData();
                setchecked([]);
            }
            
            setloading(false);
        }, { data: checked });
    }

    // const { data, error, isLoading, refetch } = useQuery(`myTasks`, loadData); 

    
    // useEffect(() => {
    //     const script = document.createElement('script');
        
    //     script.src = "https://apis.google.com/js/platform.js";
    //     script.async = true;
    //     script.defer = true;
        
    //     document.body.appendChild(script);
        
    //     return () => {
    //         document.body.removeChild(script);

    //         window.___gcfg = {
    //             parsetags: 'onload'
    //         };
    //     }
    // }, []);

    // useEffect(() => {
    //     const script = document.createElement('script');
        
    //     script.src = "https://teams.microsoft.com/share/launcher.js";
    //     script.async = true;
    //     script.defer = true;
        
    //     document.body.appendChild(script);
        
    //     return () => {
    //         document.body.removeChild(script);
    //     }
    // }, []);


    useEffect(() => {
        loadData();
    }, [window.location.pathname]);

    
    if (isLoading) {
        return  <Loader />;
    }

    if (userinfo?.userlevel < 3) {
        return <Permission />
    }


    return (
        <div className='teacherTaskBox'>
            {loading && <Loader />}

            {checked?.length ? <div className='sendGamesToStudentBox'>
                <Link onClick={deleteGames} className='btn'>{t("delete")} {t("games_title")} ({checked?.length})</Link>
            </div>: false}
            
            <div className='mainWidth shadow' style={{maxWidth:900}}>

                <nav className='breadcrumbs'>
                    <Link to={`/`}>{t("home")}</Link>
                    <MdOutlineArrowLeft />
                    <Link>{t("my_games")}</Link>
                
                </nav>

                <div className='mainMyTasksTitleBox'>
                    <h1 className='mainTitle'>{t("my_games")}</h1>
                    <nav>
                        <a onClick={() => setopenOptions(p => !p)} className='mainClick'><BsThreeDotsVertical /></a>
                        {openOptions && <ul>
                            <Link target='_blank' to='/AllTaskStatsDownload'><LuSheet /> {t("tasks_menu_8")}</Link>
                        </ul>}
                    </nav>
                </div>
                
                <div className='tasksStatsBox ' >

                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats[0]}</b>
                            <span>{t("tasks_stats_9")}</span>
                        </p>
                        <PiPencil />
                    </div>
                    {/* <div >
                        <hr />
                        <p>
                            <b>{data?.stats[1]}</b>
                            <span>{t("tasks_stats_8")}</span>
                        </p>
                        <PiBuildingsLight />
                    </div> */}
                    <div>
                        <hr />
                        <p>
                            <b>{data?.stats[2]}</b>
                            <span>{t("tasks_stats_3")}</span>
                        </p>
                        <PiStudent />
                    </div>

                </div>


                <div className='filterBox'>
                    <div>
                        {t("games_num")} ({data?.games_num})
                    </div>
                    <form>
                        <input 
                            className='searchInput' 
                            type="search" 
                            placeholder={`${t("search")}..`} 
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                text:d?.target?.value
                            }))}
                        />

                        <select className='searchInput' style={{maxWidth:180}}
                            onChange={(d) => setfilter(p => ({
                                ...p,
                                classes:d?.target?.value
                            }))}
                        >
                            <option value=''>- {t("classes")} -</option>
                            {userinfo?.classes?.map((v, k) => {
                                let cls = v?.split("-")[0];
                                let grd = v?.split("-")[1];
                                
                                return (
                                    <option key={k} value={v}>{`${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`}</option>
                                );
                                // Cls.push({name: `${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`, val:`${cls}-${grd}`});
                            })}
                        </select>
                    </form>
                </div>

                <div className='myTaskBody'>
                    {data.games?.length ? <a onClick={toggleSelectAll} className='selectAll'>{t("filter_all")}</a>: false}
                            
                    {data.games?.map((v, k) => {
                        
                        let checkClasses = filter?.classes ? false : true;
                        if (v?.classes == filter?.classes) {
                            checkClasses = true;
                        }
                        
                        if (checkClasses) {

                            let cls = v?.classes?.split("-")[0];
                            let grd = v?.classes?.split("-")[1];
    
                            let className = `${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`;
                            return (
                                <div key={k} className='taskClassesSection'>
                                    
                                    <strong className='taskClassesTitle'>{className}</strong>
    
                                    {v?.data?.map((vv, kk) => {

                                        let ck = checked?.includes(vv?._id);
    
                                        let view = filter?.text ? false : true;
                                        if (vv?.title.indexOf(filter?.text) > -1) {
                                            view = true;
                                        }
                                        
                                        
                                        let studentsAnswers = data?.answers?.filter(r => r?.task?._id == vv?._id);
                                        vv.answersQnt = studentsAnswers?.length;
                                        
                                        if (view) {
                                            
                                            return (
                                                <Games setchecked={setchecked} v={vv} checked={ck} key={kk} onSave={() => loadData()} />
                                            );
                                        }
                                    })}
    
                                    
                            
                                </div>
                            );
                        }
                        

                        
                    })}

                    {!data.games?.length ? <div className='noData'>{t("error",  { returnObjects: true })[1]}</div>: false}

                </div>

                

            </div>


        </div>
    )
}
